import apiRequest from 'client/helpers/apiRequest';
import ResearchersPage, { Researcher } from '@interfaces/researchers-page';
import { ResearchersRequestParams } from '@interfaces/researchers-request-params';

export const fetchResearchersPage = (requestParams: ResearchersRequestParams) => {
    const { page: pageNumber = 1, pageSize = 10, themeSlug, status } = requestParams;
    const params: any = { pageNumber, pageSize, status };

    if (themeSlug) {
        params.themeSlug = themeSlug;
    }

    return apiRequest.get<ResearchersPage>('/api/researchers', { params });
};

export const fetchResearcher = (id: string) =>
    apiRequest.get<Researcher>(`/api/researchers/${id}`);
